<div class="main-content" style="margin:0px !important; padding:0px !important;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12" style="padding:0px;">
                <div class="card">
                    <!--<div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>-->
                    <!--------------------------------main-content---------------------------------->

                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="main-container">

                                    <div class="myheader">
                                        <div class="row">
                                            <div class="col-md-6">
                                            </div>
                                            <div class="col-md-6">
                                                <div class="text-right">
                                                    <i class="material-icons">content_copy</i>
                                                    <i class="material-icons">email</i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12 bolder">
                                            <label>Name: </label>
                                            <input type="text" name="name" value="Invitation email v1.0" readonly />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <label>Assessment type: </label>
                                            <input type="text" name="name" value="Regular" readonly />
                                        </div>
                                    </div>

                                    <!--<div class="row">
                                        <div class="col-12">
                                            <label>Niche: </label>
                                            <input type="text" name="name" value="General" readonly />
                                        </div>
                                    </div>-->

                                    <div class="row">
                                        <div class="col-12">
                                            <label>Purpose: </label>
                                            <input type="text" name="name" value="Porpuse" readonly />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <label>Body: </label>
                                            <div class="body-content">
                                                Dear <span class='field'>&#123;Student Name&#125;</span><br />
                                                <span class='field'>&#123;Coach Name&#125;</span>
                                                is inviting you to fulfill the following assessment ...
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!--------------------------------main-content END---------------------------------->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
